import {Divider, Stack, Typography} from "@mui/material";
import Admin from "../Admin";
import Menu from "../Menu";
import {useEffect, useMemo, useState} from "react";
import {Notification} from "../../utils/models/Notification";
import {useTranslation} from "react-i18next";
import ErrorResponseDialog from "../dialog/ErrorResponseDialog";
import {getNotifications} from "../../utils/Api";
import NotificationListAdapter from "../list/NotificationListAdapter";
import DialogLoader from "../dialog/DialogLoader";

export default function NotificationDashboard() {
    const {t} = useTranslation();

    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState<TemplateStringsArray | undefined>();

    const memoizedGetNotifications = useMemo(() => {
        return async () => {
            setIsLoading(true);
            try {
                const notifications = await getNotifications();
                setNotifications(notifications);
            } catch (error: any) {
                setError(error.message);
            }
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        memoizedGetNotifications();
    }, [memoizedGetNotifications])

    return (
        <>
            {isLoading &&
                <DialogLoader loading={isLoading} onClose={() => setIsLoading(!isLoading)}/>
            }
            {error &&
                <ErrorResponseDialog errorCode={error} onClose={() => {
                    setError(undefined);
                }}/>
            }
            <Stack direction='column' className={"tools-column"}>
                <Admin/>
                <Divider/>
                <Stack 
                    padding={1} 
                    className="dashboard-content"
                >
                    <Stack gap={1} mt={1}>
                        <Typography variant={"h4"}>
                            {t("notifications_title")}
                        </Typography>
                        <NotificationListAdapter notifications={notifications}/>
                        {notifications.length > 0 &&
                            <Stack gap={2} mt={1}>
                                <Typography variant={"body1"}>
                                    {notifications.length.toString()
                                        + " notification(s)"}
                                </Typography>
                            </Stack>
                        }
                    </Stack>
                    <Stack sx={{ height: '150px' }} />
                </Stack>
            </Stack>
            <Menu/>
        </>
    )
}